"use client";
import { Title} from "@mantine/core";
import { useTranslation } from "react-i18next";
import { TabLogin } from "./tab-login";

const LoginForm = () => {
   const { t } = useTranslation("login");

   return (
      <div>
         <div className="flex flex-col p-8 gap-2 w-full">
            <Title
               pt={10}
               order={1}
               classNames={{ root: "text-tripatra-9 font-semibold" }}>
               {" "}
               {t("form.title")}{" "}
            </Title>
            <TabLogin/>
         </div>
      </div>
   );
};

export default LoginForm;
